import { executeAddonBooking, fetchAddOnDetails } from "../../../api";
import _ from "lodash";
import { gotoBookingFail } from "..";
import { BOOKING_GOTO_STEP } from "../types";

const default_guest_nationality = import.meta.env.VITE_APP_FIXED_GUEST_NATIONALITY;

export const gotoMIPaymentSuccess =
  ({ paymentIntent, customer_uid, email, first_name, last_name, nationality }) =>
  (dispatch) => {
    dispatch({ type: BOOKING_GOTO_STEP, step: 6 });
    dispatch(
      executeMIBook({
        paymentIntent,
        customer_uid,
        email,
        first_name,
        last_name,
        nationality,
      }),
    );
  };

export const executeMIBook =
  ({
    paymentIntent,
    customer_uid,
    email,
    first_name,
    last_name,
    nationality,
    guestsList,
    booked_rooms,
    source_entity,
    website_api_key,
    remarks,
  }) =>
  async (dispatch, getState) => {
    const state = getState();

    const name = _.get(state, "WebsiteMetadata.metadata.name");

    const group_uid = state.TourPriceInfo.price_info.groups[0].uid;

    const addon_data = {
      session_id: state.TourPriceInfo.price_info.session_id,
      search_uid: state.TourPriceInfo.price_info.search_uid,
      group_uid: group_uid,
      // price_data: state.TourPriceInfo.price_info.price.find(
      //   (price) => price.group_uid === group_uid
      // ),
      price_data: { ...state.TourPriceInfo.price_info.price[0], group_uid },
    };

    const customer_user_data = {
      customer_uid,
      email,
      first_name,
      last_name,
      nationality,
    };

    const book_payload = {
      payment_data: paymentIntent,
      source_entity,
      website_meta: {
        api_key: website_api_key,
        name,
      },
      remarks,
      guests: guestsList,
      addon_data,
      client_provided_pickup_point: "",
      client_provided_pickup_address: "",
      customer_user_data,
      booked_rooms,
    };

    const result = await executeAddonBooking({
      payload: book_payload,
    });

    if (!result) {
      dispatch(gotoBookingFail());
      return null;
    }

    return result;
  };

export const executeRQMIBook =
  ({ history, page_session_id, guestsList, remarks }) =>
  async (dispatch, getState) => {
    dispatch({ type: BOOKING_GOTO_STEP, step: 6 });

    const state = getState();

    const operation_date = _.get(state, "TourPriceInfo.search_data.date");
    const { api_key, name, source_entity } = state.WebsiteMetadata.metadata;
    const reference = _.get(state, "TourPriceInfo.search_data.reference");

    const addon_data = await fetchAddOnDetails(reference, source_entity);
    if (!addon_data) {
      history.push(`/failed-booking/${page_session_id}`);
      return;
    }

    const group_leader = guestsList.find((g) => g.group_leader);

    const { guest_uid: customer_uid, first_name, last_name, email } = group_leader;
    const nationality = default_guest_nationality;

    const customer_user_data = {
      customer_uid,
      email,
      first_name,
      last_name,
      nationality: group_leader.nationality || nationality,
    };

    const cleanedGuests = guestsList.map((g) => {
      const tmp: { [key: string]: string | null } = {};
      Object.entries(g).forEach(([key, value]) => {
        if (value === "") {
          tmp[key] = null;
        } else {
          tmp[key] = value;
        }
      });
      return tmp;
    });

    const book_payload = {
      operation_date,
      source_entity: source_entity,
      website_meta: {
        api_key,
        name,
      },
      remarks,
      guests: cleanedGuests,
      customer_user_data,
      booking_mode: "RQ",
      addon_data,
    };
    const result = await executeAddonBooking({
      payload: book_payload,
    });

    if (!result) {
      history.push(`/failed-booking/${page_session_id}`);
      return;
    }

    history.push(`/tour/successful-booking/${page_session_id}`);
  };
